import React, {useContext} from "react";
import {BoShowContext} from "../context/bo-show-context.jsx";
import {BoKeys} from "../../resources/bo-keys.js";

const BoShowOtherInformation = () => {
    const {boData} = useContext(BoShowContext);
    const extraInfo = boData?.extraInfo;

    if (!extraInfo) return null;

    const hasAmbiental = extraInfo?.area || extraInfo?.adminPenalty;
    const hasEvent = extraInfo?.eventName || extraInfo?.eventPersonQuantity;

    if (!hasAmbiental && !hasEvent) return null;

    return (
        <article className={"space-y-4"}>
            <h2 className={"resume-title"}>OUTRAS INFORMAÇÕES</h2>

            {
                hasAmbiental &&
                <section className={"space-y-2"}>
                    <h3 className={"!font-normal"}>Ambiental</h3>

                    <div className={"grid grid-cols-2 gap-2"}>
                        <p>Área: <span className={"info"}>{BoKeys[extraInfo?.area] ?? extraInfo?.area ?? ""}</span></p>
                        <p>Sanção administrativa imposta: <span className={"info"}>{BoKeys[extraInfo?.adminPenalty] ?? extraInfo?.adminPenalty ?? ""}</span></p>
                    </div>
                </section>
            }

            {
                hasEvent &&
                <section className={"space-y-2"}>
                    <h3 className={"!font-normal"}>Evento</h3>

                    <div className={"grid grid-cols-2 gap-2"}>
                        <p>Nome: <span className={"info"}>{extraInfo?.eventName ?? ""}</span></p>
                        <p>Total de participantes: <span className={"info"}>{extraInfo?.eventPersonQuantity ?? ""}</span></p>
                    </div>
                </section>
            }
        </article>
    );
};

export default BoShowOtherInformation;
